import useLazySelector from "common/redux/useLazySelector";
import { PositionSetting } from "domain/positionSetting";
import { loadPositionSettings } from "./longShort.actions";

export default function usePositionSettings(): PositionSetting[] {
    return useLazySelector(m => m.positionSettings, dispatch => loadPositionSettings()(dispatch), m => !m.userState.isCustomer, []);
}